module.exports = __webpack_public_path__ + "static/media/tmcf-logo-white.83e47db5.png";